import { createTrackingFormatterRegistry } from "../../../../../services/tracking/formatters";

import { createSignalFilterFormatter } from "./signals-filter-formatter";
import type { LeadsFiltersTrackingFormatterRegistry } from "./types";

const createFilterTrackingRegistry = () => {
    const registryInstance: LeadsFiltersTrackingFormatterRegistry = createTrackingFormatterRegistry();

    registryInstance.register(createSignalFilterFormatter());

    return registryInstance;
};

export const filterTrackingRegistry = createFilterTrackingRegistry();
